import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ObjektQuerySorterConfig } from 'fa-kt.types';
import { ObjektService } from '../service';

@Component({
  selector: 'fa-kt-objekt-sorter',
  templateUrl: './objekt-sorter.component.html',
  styleUrls: ['./objekt-sorter.component.css'],
})
export class ObjektSorterComponent {
  public ObjektSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public objekt: ObjektService,
  ) {
    this.ObjektSorterConfig = ObjektQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
